import { join } from 'node:path';
import { generator } from './generator.js';
import type { ComponentGeneratorOptions } from './types.js';
import { dependenciesUpdater } from './dependencies-updater.js';
import { assetsGenerator } from './assets-generator.js';

export interface ComponentGenerationResult {
  updatedDependencies: string[];
  newFiles: string[];
}

export async function componentGenerator(
  opts: ComponentGeneratorOptions
): Promise<ComponentGenerationResult> {
  const {
    template,
    projectFolder,
    assetsOutputPath,
    assetsPrefix,
    dynamicPackages,
    ...generatorOpts
  } = opts;

  const newFiles = await generator({
    ...generatorOpts,
    template: join(template, 'files'),
  });

  await assetsGenerator({
    templateRoot: template,
    projectFolder,
    outputPath: assetsOutputPath,
    assetsPrefix,
  });

  const packagesToEnsure = {
    ...dynamicPackages,
    ...(opts.importData?.packageName
      ? { [opts.importData.packageName]: '^1.0.0' }
      : {}),
  };

  const updatedDependencies = await dependenciesUpdater({
    projectFolder,
    dependenciesJsonPath: join(template, 'dependencies.json'),
    ...(Object.keys(packagesToEnsure).length
      ? { dynamicPackages: packagesToEnsure }
      : {}),
  });

  return { updatedDependencies, newFiles };
}
